import { Box, Flex, GridItem, Text } from "@chakra-ui/react";
import { NumberField } from "../../../../../../components/NumberField";
import * as React from "react";
import { Fragment } from "react";
import { MEASURES, POWER_SOURCES } from "../../../../../OrganizationQuestionnaire/helpers";
import { MissingDataGridItems } from "../../MissingDataGridItems";
import { dataTypeColours } from "./helpers";

function DimensionEmissionsGridItems({ data, sectionItems, dataType }) {
  const section = [];

  sectionItems.forEach(sectionItem => {
    const dataObject = dataType === "electricity" ?
      data[dataType].items.find(source => source.consumptionType.code === sectionItem) :
      data[dataType].items.find(source => source.consumptionType.code === sectionItem.code);

    if (dataObject && dataObject.itemsPerMeasures.length > 0) {
      section.push(dataObject.itemsPerMeasures.map(measureItem => {
        const consumptionItemName = dataType === "electricity" ?
          POWER_SOURCES[sectionItem] ?? sectionItem :
          POWER_SOURCES[sectionItem?.code] ?? sectionItem?.name ?? sectionItem?.code;

        return <Fragment key={`${dataType}-${sectionItem.code ?? sectionItem}-${measureItem.measure.id}`}>
          <GridItem>
            <Flex gap="3" inlineSize="305px" alignItems={"center"}>
              <Box
                width={3}
                height={3}
                backgroundColor={dataTypeColours[dataType]}
                borderRadius={"50%"}
                display={"inline-block"}
              />
              <Box
                display="flex"
                alignItems="center"
                fontSize="sm"
                whiteSpace="break-spaces">
                <Text><b>{consumptionItemName}</b></Text>
              </Box>
            </Flex>
          </GridItem>
          <GridItem>
            <Flex justifyContent="end" display="-webkit-box">
              <NumberField value={measureItem.consumption} />
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontSize="sm"
                whiteSpace="break-spaces">
                <Text>
                  {` (${MEASURES[measureItem.measure.code] ?? measureItem.measure.name})`}
                </Text>
              </Box>
            </Flex>
          </GridItem>
          <GridItem>
            <NumberField value={measureItem.co2Emissions} />
          </GridItem>
        </Fragment>;
      }));
    }
  });

  if (section.length === 0) {
    section.push(<MissingDataGridItems key={`${dataType}-missing`} value={0} />);
  }

  return section;
}

export default DimensionEmissionsGridItems;